import { useTranslation } from "react-i18next"
import Card from "../ui-elements/Card"
import { GlobalContext } from '../GlobalContext'
import { useContext } from "react"
import RedAlert from "../ui-elements/RedAlert"
import FormatQuestionTitle from "./FormatQuestionTitle"

type Props = {
    thisCheckPeriod: ObjectStringKeyAnyValue
}


export default function AlertsForCheckPeriod({ thisCheckPeriod }: Props) {

    const { t } = useTranslation()
    const { tableData } = useContext(GlobalContext)
    const checkPeriodAlerts = thisCheckPeriod && thisCheckPeriod.alertsForCheckPeriod ? thisCheckPeriod.alertsForCheckPeriod : []
    const numberOfAlerts = checkPeriodAlerts.length || 0

    if (!checkPeriodAlerts || checkPeriodAlerts.length === 0) {
        return null
    }
 
    return <div className={`w-full rounded border bg-red-100 border-red-400 text-red-800 flex flex-col py-1 px-2`}>


        <p className={`font-bold text-lg`}>{t('Dashboard.AlertsForCheckPeriod.alerts', { count: numberOfAlerts })}</p>


        {checkPeriodAlerts.map((alert: any, index: number) => {
            const questionId = alert.QuestionId
            const question = questionId && tableData && tableData.ChecklistQuestions && tableData.ChecklistQuestions[questionId]

            return <div key={index} className={`w-full flex flex-row gap-1 items-center justify-start`}> 
                <FormatQuestionTitle
                    question={question}
                    classString={``}
                /> :
                <p className={`italic`}>{alert.answer}</p>
            </div>
        })}


    </div>
}